module.exports = __webpack_public_path__ + "media/images/catalogs/items/options/icons/house_cleaning_products-174b1cfbb7669802d4ed4b0e34aa5a8b.svg";